import React from "react"
import { Container, Grid, Button } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./Overview.css"

export class OverviewDirectFree extends React.Component {
  render = () => {
    const { nextUrl, upgradePlan } = this.props
    return (
      <Container textAlign="center" className="white">
        <Grid centered stackable className="overview_maindiv">
          <Grid.Row style={{ paddingBottom: "0px" }}>
            <Grid.Column textAlign="center">
              <h2 className="overview__Heading">Woo hoo!</h2>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingTop: "0px" }}>
            <Grid.Column
              className="overview__Description"
              width={14}
              textAlign="center"
            >
              <p className="overview__DescriptionText">
                You’re <i>almost</i> a financial action hero! Just a few more
                steps and you’ll be ready to fly with SAVVI.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered columns={3}>
            <Grid.Column>
              <div className="overview_title">You’ve chosen “Free!”</div>
              <p>
                Who doesn’t love free!?! With this version you’ll be able to
                leverage most of the awesome capabilities of the tool:
                organizing your accounts, setting goals and getting actionable
                advice. And if you love it so much that you want more, like
                investment advice and more goals, we have an affordable paid
                option. No pressure. It’s up to you.
              </p>
            </Grid.Column>
            <Grid.Column>
              <div className="overview_title">How can it be free?</div>
              <p>
                You'll see some relevant offers from advertisers within the
                application. Want to earn more on your savings accounts? Reduce
                the interest rate you pay on your debt? You’ll see offers to
                help take those positive steps. Check them out, but you’ll never
                be forced to click or to buy from them. That’s not how we roll.
              </p>
            </Grid.Column>
            <Grid.Column>
              <div className="overview_title">Hate ads, love SAVVI?</div>
              <p>
                For only $9 a month you can get a SAVVI ad-free with additional
                functionality and no requirement to sign-in once every three
                months to maintain your account. For less than 30 cents a day
                (and even less if it’s a leap year!) you can feel more confident
                about your money. You can upgrade at any time, like right now.{" "}
                <span
                  onClick={() => upgradePlan()}
                  style={{ cursor: "pointer" }}
                  className="navlink"
                >
                  Upgrade Now!
                </span>
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingBottom: "0" }}>
            <Grid.Column
              width={12}
              textAlign="center"
              style={{ color: "#00b5ed", fontWeight: "600" }}
            >
              A few more things to know...
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <ul className="overview__List">
                <li>
                  The advice you’re going to get… it’s personalized and
                  independent. We put your best interests first. Great, right?
                </li>
                <li>
                  <span style={{ textDecoration: "underline" }}>
                    You will need to sign-in at least once every three months
                  </span>{" "}
                  to maintain your free access. The paid plan doesn't have this
                  requirement.
                </li>
              </ul>
            </Grid.Column>
            <Grid.Column width={6}>
              <ul className="overview__List">
                <li>
                  We protect your data with layers of security. SAVVI cares
                  about data privacy and security and has a SOC 2 Type II
                  Certification to prove it.
                </li>
                <li>
                  The agreements you’re about to see acknowledge our promises to
                  you. It’s stronger than a pinky swear and written by lawyers.
                </li>
              </ul>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div className="overview_details">
                <p>Ready? Okay… Review. Accept. Go!</p>
                <br />
                <Link to={nextUrl} className="navlink">
                  <Button
                    primary
                    size="big"
                    className="overview_Button"
                    data-testid="continue"
                  >
                    Continue
                  </Button>
                </Link>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}
